import { h, Component } from 'preact';
import Store from 'store/store';
import isShallowEqual from 'shallow-equals';
import s from 'components/bolt/videos/player.sss';
import Youtube from 'components/bolt/youtube/youtube';
import Vimeo from 'components/bolt/vimeo/vimeo';
import NativeVideo from 'components/bolt/nativeVideo/nativeVideo';
import Matterhorn from 'components/bolt/matterhorn/matterhorn';
import { joinClasses } from 'utils/utils';

export default class VideoPlayer extends Component {

	constructor(props) {
		super(props);

		this.hideLoader = this.hideLoader.bind(this);
		this.showLoader = this.showLoader.bind(this);
		this.toggleLoader = this.toggleLoader.bind(this);
		this.onReady = this.onReady.bind(this);

		this.disableYoutubeCookieCheck = Store.get().appData?.options?.disableYoutubeCookieCheck;
	}

	shouldComponentUpdate(nextProps) {
		return !isShallowEqual(nextProps.activeVideo, this.props.activeVideo)
			|| this.props.hiddenPlaylist !== nextProps.hiddenPlaylist
			|| !isShallowEqual(nextProps.ageGateProtected, this.props.ageGateProtected)
			|| nextProps.extraClass !== this.props.extraClass;
	}

	componentDidUpdate(prevProps) {
		if (prevProps.activeVideo !== this.props.activeVideo) {
			this.showLoader();
		}

		if (!this.props.ageGateProtected && prevProps.ageGateProtected && !this.props.noAutoplay) {
			this.play();
		}
	}

	play() {
		this.player?.play();
	}
	get duration() {
		return this.player?.duration || 0;
	}

	toggleLoader(show) {
		if (typeof show !== 'boolean') {
			show = !this.state.showLoader;
		}
		this.setState({ showLoader: show });
	}

	showLoader() {
		this.toggleLoader(true);
	}

	hideLoader() {
		this.toggleLoader(false);
	}

	onReady() {
		this.hideLoader();
		if (this.props.onLoaded) {
			this.props.onLoaded();
		}
	}

	renderVideo() {
		const {
			activeVideo,
			onEnded, onStart, onPlay, onPause,
			overrideStyles,
			noAutoplay, muted,
			isShowtimesMessage,
			isTrailerOverlay,
			ageGateProtected
		} = this.props;

		if (!activeVideo) {
			return null;
		}

		const autoplay = !(noAutoplay || activeVideo.noAutoplay || ageGateProtected);

		if (activeVideo.youtubeId) {
			return (
				<Youtube
					ref={ref => this.player = ref}
					videoId={activeVideo.youtubeId}
					onEnded={onEnded}
					onStart={onStart}
					onPlay={onPlay}
					onPause={onPause}
					onPlayerReady={this.onReady}
					autoplay={autoplay}
					isShowtimesMessage={isShowtimesMessage}
					noCookies={activeVideo.noCookies && activeVideo.noCookies !== 'Cookie Mode'}
					disableCookieCheck={this.disableYoutubeCookieCheck}
					isTrailerOverlay={isTrailerOverlay}
					isTrailer={activeVideo.isTrailer}
					key={`youtube-${activeVideo.youtubeId}`}
					muted={muted || activeVideo.muteVideo}
				/>
			);
		}
		if (activeVideo.vimeoId) {
			return (
				<Vimeo
					ref={ref => this.player = ref}
					videoId={activeVideo.vimeoId}
					videoHash={activeVideo.vimeoHash}
					autoplay={autoplay}
					onEnded={onEnded}
					onPlayerReady={this.onReady}
					isShowtimesMessage={isShowtimesMessage}
					isTrailerOverlay={isTrailerOverlay}
					isTrailer={activeVideo.isTrailer}
					key={`vimeo-${activeVideo.vimeoId}`}
					muted={muted || activeVideo.muteVideo}
				/>
			);
		}
		if (activeVideo.videoSrc) {
			return (
				<NativeVideo
					ref={ref => this.player = ref}
					activeVideo={activeVideo}
					autoplay={autoplay}
					onEnded={onEnded}
					canPlayCallback={this.onReady}
					isShowtimesMessage={isShowtimesMessage}
					isTrailerOverlay={isTrailerOverlay}
					isTrailer={activeVideo.isTrailer}
					key={`nativeVideo-${activeVideo.videoSrc}`}
					overrideStyles={overrideStyles}
					muted={muted || activeVideo.muteVideo}
					useTracking
				/>
			);
		} else if (activeVideo.disneySrc) {
			return (
				<Matterhorn
					ref={ref => this.player = ref}
					activeVideo={activeVideo}
					autoplay={autoplay}
					isShowtimesMessage={isShowtimesMessage}
					isTrailerOverlay={isTrailerOverlay}
					isTrailer={activeVideo.isTrailer}
					onPlayerReady={this.onReady}
					key={`matterhorn-${activeVideo.disneySrc}`}
					muted={muted}
				/>
			);
		}
	}

	render(props) {
		let { overrideStyles, hiddenPlaylist, extraClass } = props;
		let { showLoader } = this.state;

		return (
			<div class={joinClasses(!overrideStyles && s.container, hiddenPlaylist && s.hiddenPlaylist, extraClass)}>
				<div class={s.keepAspectRatio}>
					<div class={joinClasses(s.loader, showLoader && s.visible)} />
					{this.renderVideo()}
				</div>
			</div>
		);
	}
}
